// Pantalla `command="email-advise-otp"`. Port de la rama `when
// "email-advise-otp"` de keycloak.coffee. Pantalla de aviso ANTES de
// activar 2FA por email — explica al usuario que se va a empezar a
// pedir código por correo, y opcionalmente le permite enviar un mensaje
// de prueba para comprobar que recibe. Acciones soportadas:
//   - login            → continuar (acepta y procede al email-otp)
//   - cancel           → cancelar
//   - sendTestMessage  → enviar mensaje de prueba (solo si aún no se ha
//                        enviado)

import type { KcData } from "../kcData";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

export interface EmailAdviseOtpPageProps {
  data: KcData;
  running: boolean;
  onCustomSubmit: (action: "login" | "cancel" | "sendTestMessage") => void;
}

interface EmailAdviseOtp {
  testMessageSent?: boolean;
  userEmail?: string;
}

export function EmailAdviseOtpPage(props: EmailAdviseOtpPageProps) {
  const { data, running, onCustomSubmit } = props;
  const advise = (data.form?.emailAdviseOtp as EmailAdviseOtp | undefined) ??
    ((data as unknown as { emailAdviseOtp?: EmailAdviseOtp }).emailAdviseOtp);
  const testMessageSent = advise?.testMessageSent === true;

  return (
    <StandardPage page="email-advise-otp" data={data}>
      <div>
        <form
          id="kc-email-advise-otp-form"
          action={data.url!.loginAction}
          method="post"
        >
          {/* Texto rico (con <strong> y <a>) pre-renderizado en messages.
              Sustituimos {0} por el email del usuario cuando aplica. */}
          {testMessageSent ? (
            <div>
              <p
                className="instruction"
                dangerouslySetInnerHTML={{
                  __html: msg(
                    "emailAdviseTestSentHtml",
                    advise?.userEmail ?? "",
                  ),
                }}
              />
              <p className="instruction">{msg("emailAdviseCheckMessage")}</p>
              <p
                className="instruction"
                dangerouslySetInnerHTML={{
                  __html: msg("emailAdviseTroubleHtml"),
                }}
              />
            </div>
          ) : (
            <div>
              <p
                className="instruction"
                dangerouslySetInnerHTML={{
                  __html: msg("emailAdviseInfoHtml"),
                }}
              />
            </div>
          )}
          <div className="form-group">
            <p className="instruction">{msg("emailAdviseAction")}</p>
            <button
              type="button"
              className="btn btn-lg btn-block btn-primary"
              disabled={running}
              onClick={() => onCustomSubmit("login")}
            >
              {msg("doContinue")}
            </button>
          </div>
          <div className="form-group">
            <button
              type="button"
              className="btn btn-lg btn-block btn-default"
              disabled={running}
              onClick={() => onCustomSubmit("cancel")}
            >
              {msg("doCancel")}
            </button>
          </div>
          {!testMessageSent ? (
            <div>
              <p className="instruction">{msg("emailAdviseTestPrompt")}</p>
              <div className="form-group">
                <button
                  type="button"
                  className="btn btn-lg btn-block btn-default"
                  disabled={running}
                  onClick={() => onCustomSubmit("sendTestMessage")}
                >
                  {msg("doSendTestMessage")}
                </button>
              </div>
            </div>
          ) : null}
        </form>
      </div>
    </StandardPage>
  );
}
